export default "__VITE_ASSET__ChxgrpEJ__"